import React from "react";
import style from "./searchBar.module.scss";
import cx from "classnames";
import { CloseIcon, SearchIcon } from "@gataca/design-system/web";
import { gaColors } from "../../assets/globalConstants";
import { ImageModel } from "../../types/interfaces";
import { useTranslation } from "react-i18next";

export type SearchBarProps = {
  icon?: ImageModel;
  cleanIcon?: boolean;
  border?: boolean;
  placeholder?: string;
  className?: string;
  handleSearchedChange?: (e) => void;
  searchValue: string;
  cleanSearchBar: (x?: any) => void;
  handleSearchedValidation: ((x?: any) => void) | void | null;
};

export type SearchState = {
  searchableOptions: any[];
  searched: string;
  searchedResult: any[];
};

const SearchBar: React.FC<SearchBarProps> = React.memo((props) => {
  const {
    icon,
    border,
    placeholder,
    cleanIcon,
    className,
    handleSearchedChange,
    searchValue,
    cleanSearchBar,
    handleSearchedValidation,
  } = props;

  const { t } = useTranslation();
  const [inputIsFocused, setInputIsFocused] = React.useState(false);

  return (
    <div className={`${style.searchBar} ${className}`}>
      {icon ? (
        <SearchIcon
          className={style.searchBar__icon}
          color={gaColors.neutral1000}
          size={"16"}
        />
      ) : null}
      <div
        className={cx(
          style.searchBar__inputContainer,
          border && style.withBorder,
          inputIsFocused ? style.inputIsFocused : ""
        )}>
        <input
          id={"searchBarInput"}
          type="text"
          className={cx(style.input, "bodyRegularMD neutral600")}
          placeholder={t(placeholder)}
          value={searchValue || ""}
          onFocus={() => setInputIsFocused(true)}
          onBlur={() => setInputIsFocused(false)}
          onChange={handleSearchedChange}
          onKeyDown={handleSearchedValidation}
          aria-label="search"
        />
      </div>
      {cleanIcon && searchValue?.length > 0 ? (
        <div
          className={`${style.cleanIcon} ${style.searchBar__icons} `}
          onClick={cleanSearchBar}>
          <CloseIcon size={"12"} color={gaColors.neutral100} />
        </div>
      ) : null}
    </div>
  );
});

export default SearchBar;
